/**
 * @generated SignedSource<<6fae6162e312a2e4a900f6f0f7588213>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignmentStatus = "ACCEPTED" | "CANCELED" | "IN_PROGRESS" | "NONE" | "NOT_STARTED" | "READY_FOR_REVIEW" | "REJECTED" | "UNDER_REVIEW" | "%future added value";
export type ReviewerOverviewQuery$variables = {
  flowId: UUID;
  skip: boolean;
};
export type ReviewerOverviewQuery$data = {
  readonly module?: {
    readonly flow: {
      readonly assignedTo: {
        readonly fullName: string;
      } | null | undefined;
      readonly assignmentStatus: AssignmentStatus;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly submissionLock: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"CommentsTab_moduleComments" | "HistoryTab_module" | "OverviewTab_module" | "ReviewerTab_module">;
  } | null | undefined;
};
export type ReviewerOverviewQuery = {
  response: ReviewerOverviewQuery$data;
  variables: ReviewerOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "flowId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "flowId",
    "variableName": "flowId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submissionLock",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignmentStatus",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedToId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gwtUserId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentText",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseTo",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "GwtUser",
  "kind": "LinkedField",
  "name": "gwtUser",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lanId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReviewerOverviewQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Module",
            "kind": "LinkedField",
            "name": "module",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Flow",
                "kind": "LinkedField",
                "name": "flow",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GwtUser",
                    "kind": "LinkedField",
                    "name": "assignedTo",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OverviewTab_module"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CommentsTab_moduleComments"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReviewerTab_module"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HistoryTab_module"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReviewerOverviewQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Module",
            "kind": "LinkedField",
            "name": "module",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Flow",
                "kind": "LinkedField",
                "name": "flow",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GwtUser",
                    "kind": "LinkedField",
                    "name": "assignedTo",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dueAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignmentDueAtStatus",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "comment": {
                            "responseTo": {
                              "isNull": true
                            }
                          }
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": "COMMENT_BY_COMMENT_ID__CREATED_AT_DESC"
                      }
                    ],
                    "concreteType": "FlowCommentsConnection",
                    "kind": "LinkedField",
                    "name": "flowComments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowComment",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Flow",
                            "kind": "LinkedField",
                            "name": "flow",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v10/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "comment",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": "CREATED_AT_ASC"
                                  }
                                ],
                                "concreteType": "CommentsConnection",
                                "kind": "LinkedField",
                                "name": "commentsByResponseTo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "commentsByResponseTo(orderBy:\"CREATED_AT_ASC\")"
                              },
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "flowComments(filter:{\"comment\":{\"responseTo\":{\"isNull\":true}}},orderBy:\"COMMENT_BY_COMMENT_ID__CREATED_AT_DESC\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GwtUser",
                    "kind": "LinkedField",
                    "name": "assignedBy",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlowReviewersConnection",
                    "kind": "LinkedField",
                    "name": "flowReviewers",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowReviewer",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GwtUser",
                            "kind": "LinkedField",
                            "name": "reviewer",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": "CREATED_AT_DESC"
                      }
                    ],
                    "concreteType": "ActivitiesConnection",
                    "kind": "LinkedField",
                    "name": "activities",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Activity",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "verb",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkLocation",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "object",
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GwtUser",
                            "kind": "LinkedField",
                            "name": "gwtUser",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "activities(orderBy:\"CREATED_AT_DESC\")"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": "PRIORITY_ASC"
                  }
                ],
                "concreteType": "TasksConnection",
                "kind": "LinkedField",
                "name": "tasksByModuleFlowId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priority",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flow",
                        "kind": "LinkedField",
                        "name": "flow",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "tasksByModuleFlowId(orderBy:\"PRIORITY_ASC\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "galleryAssetComponentsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attempts",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": "ATTEMPT_DESC"
                  }
                ],
                "concreteType": "ModuleSubmissionsConnection",
                "kind": "LinkedField",
                "name": "moduleSubmissionsByModuleFlowId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModuleSubmission",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attempt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "galleryAssetSubmissionId",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "submissionStatus",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "moduleSubmissionsByModuleFlowId(orderBy:\"ATTEMPT_DESC\")"
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currentAttempt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "aa0121a15b5a9e8275de6e653db49954",
    "id": null,
    "metadata": {},
    "name": "ReviewerOverviewQuery",
    "operationKind": "query",
    "text": "query ReviewerOverviewQuery(\n  $flowId: UUID!\n  $skip: Boolean!\n) {\n  module(flowId: $flowId) @skip(if: $skip) {\n    submissionLock\n    flow {\n      id\n      name\n      assignmentStatus\n      assignedTo {\n        fullName\n        id\n      }\n    }\n    ...OverviewTab_module\n    ...CommentsTab_moduleComments\n    ...ReviewerTab_module\n    ...HistoryTab_module\n    id\n  }\n}\n\nfragment CommentAddFragment on Flow {\n  rowId\n  name\n  assignedToId\n}\n\nfragment CommentCardFragment on FlowComment {\n  ...CommentReplyFragment\n  flowId\n  comment {\n    ...EditableComment_editable\n    ...CommentOptions_comment\n    rowId\n    commentsByResponseTo(orderBy: CREATED_AT_ASC) {\n      nodes {\n        ...CommentCardResponseFragment\n        id\n      }\n    }\n    createdAt\n    commentText\n    gwtUser {\n      ...UserAvatar_gwtUser\n      id\n    }\n    id\n  }\n}\n\nfragment CommentCardResponseFragment on Comment {\n  ...CommentOptions_comment\n  ...EditableComment_editable\n  createdAt\n  rowId\n  gwtUser {\n    ...UserAvatar_gwtUser\n    id\n  }\n}\n\nfragment CommentOptions_comment on Comment {\n  rowId\n  gwtUserId\n  commentText\n  responseTo\n}\n\nfragment CommentReplyFragment on FlowComment {\n  flow {\n    name\n    assignedToId\n    id\n  }\n  flowId\n  commentId\n}\n\nfragment CommentsTab_moduleComments on Module {\n  flow {\n    rowId\n    ...CommentAddFragment\n    flowComments(filter: {comment: {responseTo: {isNull: true}}}, orderBy: COMMENT_BY_COMMENT_ID__CREATED_AT_DESC) {\n      nodes {\n        commentId\n        ...CommentCardFragment\n        id\n      }\n    }\n    id\n  }\n  id\n}\n\nfragment EditableComment_editable on Comment {\n  rowId\n  gwtUserId\n  commentText\n}\n\nfragment HistoryTab_module on Module {\n  flow {\n    activities(orderBy: CREATED_AT_DESC) {\n      nodes {\n        rowId\n        verb\n        linkLocation\n        object\n        createdAt\n        gwtUser {\n          firstName\n          lastName\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment OverviewTab_module on Module {\n  flow {\n    rowId\n    name\n    description\n    assignedAt\n    dueAt\n    ...StatusChip_flow\n    id\n  }\n  tasksByModuleFlowId(orderBy: PRIORITY_ASC) {\n    nodes {\n      priority\n      flow {\n        rowId\n        name\n        id\n      }\n      id\n    }\n  }\n  galleryAssetComponentsId\n  attempts\n}\n\nfragment ReviewerButton_Fragment on Module {\n  flowId\n  currentAttempt\n  attempts\n  flow {\n    name\n    assignmentStatus\n    id\n  }\n  moduleSubmissionsByModuleFlowId(orderBy: ATTEMPT_DESC) {\n    nodes {\n      id\n      submissionStatus\n      attempt\n    }\n  }\n}\n\nfragment ReviewerTab_module on Module {\n  ...SubmittedAssetFilesDisplay_Fragment\n  ...ReviewerButton_Fragment\n  ...StartReviewingButton_Fragment\n  ...StartNextAttemptButton_Fragment\n  flow {\n    ...StatusChip_flow\n    rowId\n    name\n    description\n    assignedAt\n    assignedBy {\n      firstName\n      lastName\n      id\n    }\n    assignedTo {\n      firstName\n      lastName\n      id\n    }\n    flowReviewers {\n      nodes {\n        reviewer {\n          firstName\n          lastName\n          id\n        }\n        id\n      }\n    }\n    dueAt\n    assignmentStatus\n    id\n  }\n  tasksByModuleFlowId(orderBy: PRIORITY_ASC) {\n    nodes {\n      flow {\n        name\n        id\n      }\n      id\n    }\n  }\n  moduleSubmissionsByModuleFlowId(orderBy: ATTEMPT_DESC) {\n    nodes {\n      submissionStatus\n      id\n    }\n  }\n  galleryAssetComponentsId\n  attempts\n}\n\nfragment StartNextAttemptButton_Fragment on Module {\n  flowId\n  currentAttempt\n  attempts\n  flow {\n    name\n    assignmentStatus\n    assignedToId\n    id\n  }\n}\n\nfragment StartReviewingButton_Fragment on Module {\n  flowId\n  currentAttempt\n  flow {\n    name\n    assignmentStatus\n    assignmentDueAtStatus\n    assignedToId\n    id\n  }\n  moduleSubmissionsByModuleFlowId(orderBy: ATTEMPT_DESC) {\n    nodes {\n      id\n      submissionStatus\n      attempt\n    }\n  }\n}\n\nfragment StatusChip_flow on Flow {\n  dueAt\n  assignmentStatus\n  assignmentDueAtStatus\n}\n\nfragment SubmittedAssetFilesDisplay_Fragment on Module {\n  flow {\n    assignedTo {\n      fullName\n      id\n    }\n    id\n  }\n  moduleSubmissionsByModuleFlowId(orderBy: ATTEMPT_DESC) {\n    nodes {\n      attempt\n      galleryAssetSubmissionId\n      createdAt\n      id\n    }\n  }\n}\n\nfragment UserAvatar_gwtUser on GwtUser {\n  id\n  firstName\n  lastName\n  lanId\n}\n"
  }
};
})();

(node as any).hash = "abc704f14a9d703fe41e14a82d35c2ba";

export default node;
